import memoizeOne from 'memoize-one';
import makeRequest from './makeRequest';

const mapRequests = memoizeOne((
client,
requests,
promptRequestAccess) =>
Object.keys(requests).
reduce((mappedRequests, requestKey) => {
  const {
    mutation,
    query,
    module,
    buildVariables,
    fetchPolicy,
    ignoreCache, // deprecated - use fetchPolicy directly
    useGenericError = true,
    isSilent = false
  } = requests[requestKey];

  const requestFn = mutation ? client.mutate : client.query;

  return {
    ...mappedRequests,
    [requestKey]: (input) => makeRequest(
      requestFn,
      {
        mutation,
        query,
        fetchPolicy: fetchPolicy || (ignoreCache ? 'network-only' : void 0),
        context: { module },
        variables: buildVariables(input),
        isSilent,
        useGenericError
      },
      promptRequestAccess
    )
  };
}, {}));

export default mapRequests;